import { configureStore } from "@reduxjs/toolkit";
import ModalReducer from "../ReduxSlices/ModalSlice";
import AuthReducer from "../ReduxSlices/AuthSlice";
import TimeReducer from "../ReduxSlices/TimeSlice";
import PerpsReducer from "../ReduxSlices/PerpSlice";
import LiquidationReducer from "../ReduxSlices/LiquidationSlice";
import TradeReducer from "../ReduxSlices/TradeSlice";
import PointsReducer from "../ReduxSlices/PointsSlice";

export const Store = configureStore({
  reducer: {
    modal: ModalReducer,
    auth: AuthReducer,
    time: TimeReducer,
    perps: PerpsReducer,
    liquidation: LiquidationReducer,
    trade: TradeReducer,
    points: PointsReducer,
  },
});